if (!customElements.get('features-video-section')) {
  class FeaturesVideoSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initVideo();
    }

    initVideo() {
      // Video autoplay is handled by HTML attributes only
      // No JS initialization needed
    }
  }

  customElements.define('features-video-section', FeaturesVideoSection);
}
